import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useInvoiceCodes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const InvoiceCodesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="invoiceCodes"
      hook={useInvoiceCodes}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addInvoiceCode"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="invoiceCode"
    />
  );
};

export default InvoiceCodesPage; 